var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2966",
    "data-name": "Group 2966",
    transform: "translate(-959 -346)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6067",
    "data-name": "Rectangle 6067",
    width: 29,
    height: 29,
    transform: "translate(959 346)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M3520.167,1370.166v-8.333h-8.333a.833.833,0,1,1,0-1.667h8.333v-8.333a.833.833,0,1,1,1.667,0v8.333h8.333a.833.833,0,0,1,0,1.667h-8.333v8.333a.833.833,0,1,1-1.667,0Z",
    transform: "translate(-554.208 -3091.953) rotate(45)",
    fill: "#505050"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelBtn);
export default __webpack_public_path__ + "static/media/cancel-btn.95230f29.svg";
export { ForwardRef as ReactComponent };